<template>
    <div>

        <div v-if="lc_data!=null && org_id!='2'">
        <div class="cardbody">
            <div class="row">
                <div class="col-3 pb-0">
                    <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/vvp/vvp_logo.jpg" width="150%"
                        height="100%" alt="" class="schlImg" />
                </div>
                <div class="col-8 pb-0">
                    <center>
                        <h4 class="trust-name">
                            {{org_basic_data.trust_name}}
                        </h4>
                         <h2 class="schl-name">
                            Vishwakarma Vidyalaya {{ org_id == '1' ? 'English' : 'Marathi' }}
                            {{ lc_data.section_name ? lc_data.section_name : 'Primary' }}
                        </h2>
                        <div class="lcheading1">
                            <h4 class="stretch2">An I.S.O. 21001 - 2018 Certified School</h4>
                        </div>
                    </center>
                    <center>
                        <span>666, Upper Indira Nagar, Bibwewadi, Pune 37</span>
                        <br />
                        <span v-if="lc_data.section_name =='Secondary'"> Phone: 9156286954 </span>
                        <span v-else> Phone: 9156291049 </span>
                        <span style="margin-left: 5px;">
                            email: vvschool@vvp.edu.in
                        </span>
                    </center>
                </div>
            </div>
            <v-row justify="center" dense v-if="org_id == 2" translate="no" class="notranslate" style="font-size: 12px;">
                <b>शाळा मान्यता क्र.- माध्यमिक एस.एस.एन.१०९५/५९०२ माशि .१  दि. २०/०१/१९९६ (माध्यम – मराठी)</b>
                <b>ज्युनिअर कॉलेज – एच.एस.सी./ १७०३/(१९७/०३) उमाशि.१ दि.०९/०६/२००३ (माध्यम:सायन्स–इंग्रजी व कॉमर्स – मराठी )</b>
            </v-row>
            <hr class="hr-tag" />
            <hr class="hr-tag2" />
            <div class="lcheading2 mr-5">
                <center>
                    <h3 class="stretch2">School Leaving Certificate</h3>
                </center>
            </div>
            <center>
                <span v-if="lc_data.section_name =='Secondary'" style="font-size: 12px;">
                    (According to rule No. 17 grant aid code) Secondary School Reg.No SSN / 1091 / 2888 / MS - 1 Date
                    3.2.92
                </span>
                <span v-else-if="lc_data.section_name =='Higher Secondary'" style="font-size: 12px;">
                    (According to rule No. 17 grant aid code) Reg. No. HSC / 1708 / (181 / 08) HSE 25.7.2008
                </span>
                <span v-else style="font-size: 13px;">
                    (According to rule No. 17 grant aid code) School Reg.No VLS 1089 / CR 4578 Pri - 3 Date 3.2.1992
                </span>
            </center>
            <hr class="hr-tag2" />
            <div class="school-info">
                <div class="row">
                    <div class="col-4">
                        <span>LC No: </span>
                        <span class="dotted-underline" style="width: 109px;line-height: 0.6rem;"
                            v-if="lc_data.certificate_no !== null && lc_data.certificate_no !== ''">{{lc_data.certificate_no}}</span>
                        <span class="dotted-underline" style="width: 109px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>
                    <div class="col-5">
                        <span>PEN No: </span>
                        <span class="dotted-underline" style="width: 222px;line-height: 0.6rem;"
                            v-if="lc_data.pen_no !== null && lc_data.pen_no !== ''">{{lc_data.pen_no}}</span>
                        <span class="dotted-underline" style="width: 222px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>
                    <div class="col-3">
                        <span>GR.No: </span>
                        <span class="dotted-underline " style="width: 43px;line-height: 0.6rem;"
                            v-if="lc_data.gr_number !== null && lc_data.gr_number !== ''">{{lc_data.gr_number}}</span>
                        <span class="dotted-underline " style="width: 43px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>
                </div>
                <div class="row">
                    <!-- <div class="col-4">U-Dise No. : {{lc_data.udise_no}}</div> -->
                    <div class="col-4 py-1">
                        <span>U-Dise No. : </span>
                        <span v-if="lc_data.udise_no !== null && lc_data.udise_no !== ''">{{lc_data.udise_no}}</span>
                        <span v-else style="font-weight: bold;">----</span>
                    </div>
                    <div class="col-4 py-1">
                    <span>Apaar ID : </span>   
                    <span class="dotted-underline" style="width: 133px;line-height: 0.6rem;"
                            v-if="lc_data.apaar_id !== null && lc_data.apaar_id !== ''">{{lc_data.apaar_id}}</span>
                        <span class="dotted-underline" style="width: 133px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>  
                    </div>               
                    <div v-if="lc_data.section_name !='Secondary'" class="col-4 py-1">Medium : {{lc_data.school_medium}}</div>
                    <div v-if="lc_data.section_name =='Secondary'" class="col-3 py-1">Index No.: 11.11.090</div>
                </div>
                <div class="row">
                    <div class="col-5 pr-0 py-2">
                        <span>Student ID : </span>
                        <span class="dotted-underline" style="width: 173px;line-height: 0.6rem;"
                            v-if="lc_data.saral_id !== null && lc_data.saral_id !== ''">{{lc_data.saral_id}}</span>
                        <span class="dotted-underline" style="width: 173px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>
                    <div v-if="lc_data.section_name =='Higher Secondary'" class="col-2 px-0 pt-2" style="margin-left: -20px;">Board : HSC</div>
                    <div v-else class="col-2 px-0 pb-0" style="margin-left: -20px;">Board : SSC</div>
                    <div class="col-5 pl-0 py-2">
                        <span>UID No.(Aadhaar No.) : </span>
                        <span class="dotted-underline" style="width: 95px;line-height: 0.6rem;"
                            v-if="lc_data.aadhar_no !== null && lc_data.aadhar_no !== ''">{{lc_data.aadhar_no}}</span>
                        <span class="dotted-underline" style="width: 95px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>
                </div>
            </div>
            <hr class="hr-tag2" />
            <div class="stud-info">
                <div class="row">
                    <div class="col-12">
                        <span><b>1.Name of Pupil in full:</b></span>
                    
                    
                        <span><b>(Name) </b></span>
                        <span class="dotted-underline" style="width: 500px;"
                            v-if="lc_data.first_name !== null && lc_data.first_name !== ''">{{ lc_data.first_name
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 109px;font-weight:bold">----</span>
                    </div>

                </div>
                <div class="row">

                    <div class="col-6">
                        <span><b>(Father's Name) </b></span>
                        <span class="dotted-underline" style="width: 240px;"
                            v-if="lc_data.middle_name !== null && lc_data.middle_name !== ''">{{ lc_data.middle_name
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 239px;font-weight:bold">----</span>
                    </div>

                    <div class="col-6">
                        <span><b>(Surname) </b></span>
                        <span class="dotted-underline" style="width: 265px;"
                            v-if=" lc_data.last_name !==null && lc_data.last_name !==''">{{ lc_data.last_name }}</span>
                        <span v-else class=" dotted-underline" style="width: 265px;font-weight:bold">----</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <span><b>2.Mother Name (in full) : </b></span>
                        <span class="dotted-underline" style="width: 559px;"
                            v-if="lc_data.mother_first_name !== null && lc_data.mother_first_name !== ''">{{
                            lc_data.mother_first_name }}</span>
                        <span v-else class="dotted-underline" style="width: 559px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span><b>3. Nationality : </b></span>
                        <span class="dotted-underline" style="width: 249px;"
                            v-if="lc_data.nationality !== null && lc_data.nationality !== ''">{{ lc_data.nationality
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 249px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span><b> Mother Tongue : </b></span>
                        <span class="dotted-underline" style="width: 235px;"
                            v-if="lc_data.mothertoungue !== null && lc_data.mothertoungue !== ''">{{
                            lc_data.mothertoungue }}</span>
                        <span v-else class="dotted-underline" style="width: 235px;font-weight:bold">----</span>

                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <span><b>4.Religion : </b></span>
                        <span class="dotted-underline" style="width: 81px;"
                            v-if="lc_data.religion !== null && lc_data.religion !== ''">{{ lc_data.religion }}</span>
                        <span v-else class="dotted-underline" style="width: 81px;font-weight:bold">----</span>
                    </div>
                    <div class="col-5">
                        <span><b>Caste : </b></span>
                        <span class="dotted-underline" style="width: 240px;"
                            v-if="lc_data.caste !== null && lc_data.caste !== ''">{{ lc_data.caste }}</span>
                        <span v-else class="dotted-underline" style="width: 240px;font-weight:bold">----</span>
                    </div>
                    <div class="col-4">
                        <span><b>Sub-Caste : </b></span>
                        <span class="dotted-underline" style="width: 142px;"
                            v-if="lc_data.subcaste !== null && lc_data.subcaste !== ''">{{ lc_data.subcaste }}</span>
                        <span v-else class="dotted-underline" style="width: 142px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span><b>5. Birth Place : </b></span>
                        <span class="dotted-underline" style="width: 248px;"
                            v-if="lc_data.birth_place !== null && lc_data.birth_place !== ''">{{ lc_data.birth_place
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 248px;font-weight:bold">----</span>
                    </div>
                    <div class="col-3">
                        <span><b>Tal : </b></span>
                        <span class="dotted-underline" style="width: 113px;"
                            v-if="lc_data.birth_taluka !== null && lc_data.birth_taluka !== ''">{{ lc_data.birth_taluka
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 113px;font-weight:bold">----</span>
                    </div>
                    <div class="col-3">
                        <span><b>Dist : </b></span>
                        <span class="dotted-underline" style="width: 112px;"
                            v-if="lc_data.birth_district !== null && lc_data.birth_district !== ''">{{
                            lc_data.birth_district }}</span>
                        <span v-else class="dotted-underline" style="width: 112px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span class="ml-5"><b>State : </b></span>
                        <span class="dotted-underline" style="width: 287px;"
                            v-if="lc_data.birth_state !== null && lc_data.birth_state !== ''">{{ lc_data.birth_state
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 287px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span><b>Country : </b></span>
                        <span class="dotted-underline" style="width: 285px;"
                            v-if="lc_data.birth_country !== null && lc_data.birth_country !== ''">{{
                            lc_data.birth_country }}</span>
                        <span v-else class="dotted-underline" style="width: 285px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span> <b>6. Date of Birth (in figure) : </b></span>
                        <span class="dotted-underline" style="width: 540px;"
                            v-if="lc_data.dob_fig !== null && lc_data.dob_fig !== ''">{{ lc_data.dob_fig }}</span>
                        <span v-else class="dotted-underline" style="width: 540px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span> <b>7. Date of Birth (in words) : </b></span>
                        <span class="dotted-underline" style="width: 537px;"
                            v-if="lc_data.dob_words !== null && lc_data.dob_words !== ''">{{ lc_data.dob_words }}</span>
                        <span v-else class="dotted-underline" style="width: 537px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span> <b>8. Date of Admission : </b></span>
                        <span class="dotted-underline" style="width: 195px;"
                            v-if="lc_data.doa !== null && lc_data.doa !== ''">{{ lc_data.doa }}</span>
                        <span v-else class="dotted-underline" style="width: 195px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span> <b> Standard : </b></span>
                        <span class="dotted-underline" style="width: 274px;"
                            v-if="lc_data.admittedstandard !== null && lc_data.admittedstandard !== ''">{{
                            lc_data.admittedstandard }}</span>
                        <span v-else class="dotted-underline" style="width: 274px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-9">
                        <span> <b>9. Previous School Name : </b></span>
                        <span class="dotted-underline" style="width: 355px;"
                            v-if="lc_data.last_school !== null && lc_data.last_school !== ''">{{ lc_data.last_school
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 355px;font-weight:bold">----</span>
                    </div>
                    <div class="col-3">
                        <span> <b> Std : </b></span>
                        <span class="dotted-underline" style="width: 125px;"
                            v-if="lc_data.previousschoolpassingstandard !== null && lc_data.previousschoolpassingstandard !== ''">{{
                            lc_data.previousschoolpassingstandard }}</span>
                        <span v-else class="dotted-underline" style="width: 125px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span> <b>10. Progress: </b></span>
                        <span class="dotted-underline" style="width: 257px;"
                            v-if="lc_data.progress !== null && lc_data.progress !== ''">{{ lc_data.progress }}</span>
                        <span v-else class="dotted-underline" style="width: 257px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span> <b> Conduct : </b></span>
                        <span class="dotted-underline" style="width: 277px;"
                            v-if="lc_data.conduct !== null && lc_data.conduct !== ''">{{ lc_data.conduct }}</span>
                        <span v-else class="dotted-underline" style="width: 277px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span><b>11. Date of School Leaving : </b></span>
                        <span class="dotted-underline" style="width: 526px;"
                            v-if="lc_data.last_date_of_school !== null && lc_data.last_date_of_school !== ''">{{
                            lc_data.last_date_of_school }}</span>
                        <span v-else class="dotted-underline" style="width: 526px;font-weight:bold">----</span>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-12">
                        <span><b>12. Standard in which studying and since when(in Words) : </b></span>
                        <span class="dotted-underline">{{ lc_data.std_in_words }} and {{ lc_data.standard_since_when }}</span>
                    </div>
                </div> -->
                <div class="row">
                    <div class="col-12">
                        <span><b>12. Standard in which studying and since when: </b></span>
                        <!-- <span class="dotted-underline" style="width: 302px;">{{ lc_data.standard }} and {{ lc_data.standard_since_when }}</span> -->
                        <span style="width: 302px;">
                            <b> Std. </b>
                            <span class="dotted-underline"
                                v-if="lc_data.standard !== null && lc_data.standard !== ''">{{ lc_data.standard }}
                            </span>
                            <span v-else class="dotted-underline" style="font-weight: bold;">----</span>&nbsp;
                            <b> Since </b>
                            <span class="dotted-underline"
                                v-if="lc_data.standard_since_when !== null && lc_data.standard_since_when !== ''"> {{
                                lc_data.standard_since_when }}</span>
                            <span v-else class="dotted-underline" style="font-weight: bold;">----</span>
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span><b>13. Reason of leaving school : </b></span>
                        <span class="dotted-underline" style="width: 511px;"
                            v-if="lc_data.reason !== null && lc_data.reason !== ''">{{ lc_data.reason }}</span>
                        <span v-else class="dotted-underline" style="width: 511px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span><b>14. Remark : </b></span>
                        <span class="dotted-underline" style="width: 634px;"
                            v-if="lc_data.remark !== null && lc_data.remark !== ''">{{ lc_data.remark }}</span>
                        <span v-else class="dotted-underline" style="width: 634px;font-weight:bold">----</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <span><b>Certified that the above information is in accordance with School General Register.
                            </b></span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <span><b>Date : {{ lc_data.gen_date }}</b></span>
                    </div>
                </div>
                <br />
                <br />
                <br />
                <div class="row pt-2">
                    <div class="col-4">
                        <span>
                            <center><b>Class Teacher</b></center>
                        </span>
                    </div>
                    <div class="col-4">
                        <span>
                            <center><b>Clerk</b></center>
                        </span>
                    </div>
                    <div class="col-4">
                        <span>
                            <center><b>Headmistress</b></center>
                        </span>
                    </div>
                </div>
                <hr class="hr-tag2" />
                <div class="row" style="line-height: 1.2rem;">
                    <div class="col-1 pt-2 pb-1 ml-none">Note:</div>
                    <div class="col-11 pt-2 pb-1 notranslate" v-if="org_id == 2" translate="no">
                        <div>1)शाळा सोडतेवेळी देण्यात येणाऱ्या लिव्हिंग सर्टिफिकेटमध्ये करावयाची कोणतीही दुरुस्ती तांबड्या शाईने मुख्याध्यापकाने संक्षिप्त सहीनिशी करावी.</div>
                        <div>2)  शाळा सोडण्याच्या दाखल्यामध्ये अनधिकृतरित्या बदल केल्यास संबंधितांवर कायदेशीर कारवाई करण्यात येईल.</div>
                    </div>
                    <div class="col-11 pt-2 pb-1" v-else>
                        <div>1) Any changes in school leaving certificate should be carried out in red ink with the
                            initiation of the Headmistress</div>
                        <div>2) Any infringenment of this rule is liable to rustication or other suitable
                            punishment.</div>
                    </div>
                    
     
                </div>
            </div>
        </div>
        </div>

        <div v-if="lc_data!=null && org_id!='1'">
        <div class="cardbody">
            <div class="row">
                <div class="col-2 pb-0">
                    <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/vvp/vvp_logo.jpg" width="150%"
                        height="100%" alt="" class="schlImg" />
                </div>
                <div class="col-8 pb-0">
                    <center>
                        <h4 class="trust-name">
                             {{org_basic_data.trust_name}}
                        </h4>
                         <h2 class="schl-name">
                            {{lc_data.school_name_by_section}}
                        </h2>
                        <div>
                            <h4 class="stretch2">An I.S.O. 21001 - 2018 Certified School</h4>
                        </div>
                    </center>
                    <center>
                        <span>{{org_basic_data.address}}</span>
                        <br />
                        <span v-if="lc_data.section_name =='Secondary'"> Phone: 9156286954 </span>
                        <span v-else> Phone: 9156291049 </span>
                        <span style="margin-left: 5px;">
                            email: vvschool@vvp.edu.in
                        </span>
                    </center>
                </div>
            </div>
            <v-row justify="center" dense v-if="org_id == 2" translate="no" class="notranslate" style="font-size: 12px;">
                <b>शाळा मान्यता क्र.- माध्यमिक एस.एस.एन.१०९५/५९०२ माशि .१  दि. २०/०१/१९९६ (माध्यम – मराठी)</b>
                <b>ज्युनिअर कॉलेज – एच.एस.सी./ १७०३/(१९७/०३) उमाशि.१ दि.०९/०६/२००३ (माध्यम:सायन्स–इंग्रजी व कॉमर्स – मराठी )</b>
            </v-row>
            <v-row dense>
                <div class="row">
                     <div style="padding-bottom: 0 !important;" class="col-4 pl-5">
                        <h5>U-Dise No. : <b>{{ lc_data.udise_no ? lc_data.udise_no : '----' }}</b></h5>
                    </div>
                    <div style="padding-bottom: 0 !important;" class="col-4">
                        <h5 style="margin-left: 40px;">बोर्ड :<span> एस.एस.सी. (महाराष्ट्र)</span>
                        <div>एच.एस.सी. (महाराष्ट्र)</div></h5>
                        <!-- <h5 style="margin-left: 70px;"></h5> -->
                    </div>
                    <div style="padding-bottom: 0 !important;" class="col-4">
                        <h5>Index No. : S १ १.११.०९१</h5>
                        <h5 style="margin-left: 67px;">J १ १. १५.०४५</h5>
                    </div>
                </div>
            </v-row>
            <hr class="hr-tag" />
            <hr class="hr-tag2" />
            <div class="lcheading2_marathi mr-5">
                <center>
                    <h3 class="stretch2">School Leaving Certificate</h3>
                </center>
            </div>
            <center>
                <span v-if="lc_data.section_name =='Secondary'" style="font-size: 12px;">
                   (माध्यमिक शाळा संचिता नियम क्र. १७ व परिशिष्ट ४ प्रमाणे)
                </span>
                <span v-else-if="lc_data.section_name =='Higher Secondary'" style="font-size: 12px;">
                    (माध्यमिक शाळा संचिता नियम क्र. १७ व परिशिष्ट ४ प्रमाणे)
                </span>
                <span v-else style="font-size: 13px;">
                 (माध्यमिक शाळा संचिता नियम क्र. १७ व परिशिष्ट ४ प्रमाणे)
                </span>
            </center>
            <hr class="hr-tag2" />
            <div class="school-info">
                <div class="row">
                     <div class="col-6 pr-0 py-2">
                        <span>GR.No. :</span>
                        <span class="dotted-underline " style="width: 43px;line-height: 0.6rem;"
                            v-if="lc_data.gr_number !== null && lc_data.gr_number !== ''">{{lc_data.gr_number}}</span>
                        <span class="dotted-underline " style="width: 43px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>
                    <div class="col-6 pr-0 py-2">
                        <span>LC No: : </span>
                        <span class="dotted-underline" style="width: 109px;line-height: 0.6rem;"
                            v-if="lc_data.certificate_no !== null && lc_data.certificate_no !== ''">{{lc_data.certificate_no}}</span>
                        <span class="dotted-underline" style="width: 109px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>
                </div>
                <div class="row">
                     <div class="col-6 pr-0 py-2">
                        <span>PEN No. : </span>
                        <span class="dotted-underline" style="width: 222px;line-height: 0.6rem;"
                            v-if="lc_data.pen_no !== null && lc_data.pen_no !== ''">{{lc_data.pen_no}}</span>
                        <span class="dotted-underline" style="width: 222px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>

                     <div class="col-6 pr-0 py-2">
                    <span>Apaar ID :</span>   
                    <span class="dotted-underline" style="width: 133px;line-height: 0.6rem;"
                            v-if="lc_data.apaar_id !== null && lc_data.apaar_id !== ''">{{lc_data.apaar_id}}</span>
                        <span class="dotted-underline" style="width: 133px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>  
                    </div>     
                    <!-- <div v-if="lc_data.section_name !='Secondary'" class="col-4 py-1">माध्यम : {{lc_data.school_medium}}</div>
                    <div v-if="lc_data.section_name =='Secondary'" class="col-3 py-1">अनुक्रमांक.: ११.११.०९०</div> -->
                </div>
                <div class="row">
                    <div class="col-6 pr-0 py-2">
                        <span>Student ID :</span>
                        <span class="dotted-underline" style="width: 173px;line-height: 0.6rem;"
                            v-if="lc_data.udise_no !== null && lc_data.udise_no !== ''">{{lc_data.saral_id}}</span>
                        <span class="dotted-underline" style="width: 173px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>
                    <!-- <div v-if="lc_data.section_name =='Higher Secondary'" class="col-2 px-0 pt-2" style="margin-left: -20px;">बोर्ड : एच.एस.सी.</div> -->
                    <!-- <div v-else class="col-2 px-0 pb-0" style="margin-left: -20px;">बोर्ड : एस.एस.सी.</div> -->
                    <div class="col-6 pr-0 py-2">
                        <span>UID No.(Aadhaar No.) : </span>
                        <span class="dotted-underline" style="width: 95px;line-height: 0.6rem;"
                            v-if="lc_data.aadhar_no !== null && lc_data.aadhar_no !== ''">{{lc_data.aadhar_no}}</span>
                        <span class="dotted-underline" style="width: 95px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>
                </div>
            </div>
            <hr class="hr-tag2" />
            <div class="stud-info">
                <div class="row">
                    <div class="col-12">
                        <span><b>Name of Pupil in full:</b></span>
                    
                    
                        <span><b>(Name) </b></span>
                        <span class="dotted-underline" style="width: 500px;"
                            v-if="lc_data.first_name !== null && lc_data.first_name !== ''">{{ lc_data.first_name
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 109px;font-weight:bold">----</span>
                    </div>

                </div>
                <div class="row">

                    <div class="col-6">
                        <span><b>(Father's Name) </b></span>
                        <span class="dotted-underline" style="width: 240px;"
                            v-if="lc_data.middle_name !== null && lc_data.middle_name !== ''">{{ lc_data.middle_name
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 239px;font-weight:bold">----</span>
                    </div>

                    <div class="col-6">
                        <span><b>(Surname) </b></span>
                        <span class="dotted-underline" style="width: 265px;"
                            v-if=" lc_data.last_name !==null && lc_data.last_name !==''">{{ lc_data.last_name }}</span>
                        <span v-else class=" dotted-underline" style="width: 265px;font-weight:bold">----</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <span><b>Mother Name (in full) : </b></span>
                        <span class="dotted-underline" style="width: 559px;"
                            v-if="lc_data.mother_first_name !== null && lc_data.mother_first_name !== ''">{{
                            lc_data.mother_first_name }}</span>
                        <span v-else class="dotted-underline" style="width: 559px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span><b>Nationality : </b></span>
                        <span class="dotted-underline" style="width: 249px;"
                            v-if="lc_data.nationality !== null && lc_data.nationality !== ''">{{ lc_data.nationality
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 249px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span><b> Mother Tongue : </b></span>
                        <span class="dotted-underline" style="width: 235px;"
                            v-if="lc_data.mothertoungue !== null && lc_data.mothertoungue !== ''">{{
                            lc_data.mothertoungue }}</span>
                        <span v-else class="dotted-underline" style="width: 235px;font-weight:bold">----</span>

                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <span><b>Religion : </b></span>
                        <span class="dotted-underline" style="width: 81px;"
                            v-if="lc_data.religion !== null && lc_data.religion !== ''">{{ lc_data.religion }}</span>
                        <span v-else class="dotted-underline" style="width: 81px;font-weight:bold">----</span>
                    </div>
                    <div class="col-5">
                        <span><b>Caste : </b></span>
                        <span class="dotted-underline" style="width: 240px;"
                            v-if="lc_data.caste !== null && lc_data.caste !== ''">{{ lc_data.caste }}</span>
                        <span v-else class="dotted-underline" style="width: 240px;font-weight:bold">----</span>
                    </div>
                    <div class="col-4">
                        <span><b>Sub-Caste : </b></span>
                        <span class="dotted-underline" style="width: 142px;"
                            v-if="lc_data.subcaste !== null && lc_data.subcaste !== ''">{{ lc_data.subcaste }}</span>
                        <span v-else class="dotted-underline" style="width: 142px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span><b>Birth Place : </b></span>
                        <span class="dotted-underline" style="width: 248px;"
                            v-if="lc_data.birth_place !== null && lc_data.birth_place !== ''">{{ lc_data.birth_place
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 248px;font-weight:bold">----</span>
                    </div>
                    <div class="col-3">
                        <span><b>Tal : </b></span>
                        <span class="dotted-underline" style="width: 113px;"
                            v-if="lc_data.birth_taluka !== null && lc_data.birth_taluka !== ''">{{ lc_data.birth_taluka
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 113px;font-weight:bold">----</span>
                    </div>
                    <div class="col-3">
                        <span><b>Dist : </b></span>
                        <span class="dotted-underline" style="width: 112px;"
                            v-if="lc_data.birth_district !== null && lc_data.birth_district !== ''">{{
                            lc_data.birth_district }}</span>
                        <span v-else class="dotted-underline" style="width: 112px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span class="ml-5"><b>State : </b></span>
                        <span class="dotted-underline" style="width: 287px;"
                            v-if="lc_data.birth_state !== null && lc_data.birth_state !== ''">{{ lc_data.birth_state
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 287px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span><b>Country : </b></span>
                        <span class="dotted-underline" style="width: 285px;"
                            v-if="lc_data.birth_country !== null && lc_data.birth_country !== ''">{{
                            lc_data.birth_country }}</span>
                        <span v-else class="dotted-underline" style="width: 285px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span> <b>Date of Birth (in figure) : </b></span>
                        <span class="dotted-underline" style="width: 540px;"
                            v-if="lc_data.dob_fig !== null && lc_data.dob_fig !== ''">{{ lc_data.dob_fig }}</span>
                        <span v-else class="dotted-underline" style="width: 540px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span> <b>Date of Birth (in words) : </b></span>
                        <span class="dotted-underline" style="width: 537px;"
                            v-if="lc_data.dob_words !== null && lc_data.dob_words !== ''">{{ lc_data.dob_words }}</span>
                        <span v-else class="dotted-underline" style="width: 537px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span> <b>Date of Admission : </b></span>
                        <span class="dotted-underline" style="width: 195px;"
                            v-if="lc_data.doa !== null && lc_data.doa !== ''">{{ lc_data.doa }}</span>
                        <span v-else class="dotted-underline" style="width: 195px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span> <b> Standard : </b></span>
                        <span class="dotted-underline" style="width: 274px;"
                            v-if="lc_data.admittedstandard !== null && lc_data.admittedstandard !== ''">{{
                            lc_data.admittedstandard }}</span>
                        <span v-else class="dotted-underline" style="width: 274px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-9">
                        <span> <b>Previous School Name : </b></span>
                        <span class="dotted-underline" style="width: 355px;"
                            v-if="lc_data.last_school !== null && lc_data.last_school !== ''">{{ lc_data.last_school
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 355px;font-weight:bold">----</span>
                    </div>
                    <div class="col-3">
                        <span> <b> Std : </b></span>
                        <span class="dotted-underline" style="width: 125px;"
                            v-if="lc_data.previousschoolpassingstandard !== null && lc_data.previousschoolpassingstandard !== ''">{{
                            lc_data.previousschoolpassingstandard }}</span>
                        <span v-else class="dotted-underline" style="width: 125px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span> <b>Progress: </b></span>
                        <span class="dotted-underline" style="width: 257px;"
                            v-if="lc_data.progress !== null && lc_data.progress !== ''">{{ lc_data.progress }}</span>
                        <span v-else class="dotted-underline" style="width: 257px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span> <b> Conduct : </b></span>
                        <span class="dotted-underline" style="width: 277px;"
                            v-if="lc_data.conduct !== null && lc_data.conduct !== ''">{{ lc_data.conduct }}</span>
                        <span v-else class="dotted-underline" style="width: 277px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span><b>Date of School Leaving : </b></span>
                        <span class="dotted-underline" style="width: 526px;"
                            v-if="lc_data.last_date_of_school !== null && lc_data.last_date_of_school !== ''">{{
                            lc_data.last_date_of_school }}</span>
                        <span v-else class="dotted-underline" style="width: 526px;font-weight:bold">----</span>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-12">
                        <span><b>12. Standard in which studying and since when(in Words) : </b></span>
                        <span class="dotted-underline">{{ lc_data.std_in_words }} and {{ lc_data.standard_since_when }}</span>
                    </div>
                </div> -->
                <div class="row">
                    <div class="col-12">
                        <span><b>Standard in which studying and since when: </b></span>
                        <!-- <span class="dotted-underline" style="width: 302px;">{{ lc_data.standard }} and {{ lc_data.standard_since_when }}</span> -->
                        <span style="width: 302px;">
                            <b> Std. </b>
                            <span class="dotted-underline"
                                v-if="lc_data.standard !== null && lc_data.standard !== ''">{{ lc_data.standard }}
                            </span>
                            <span v-else class="dotted-underline" style="font-weight: bold;">----</span>&nbsp;
                            <b> Since </b>
                            <span class="dotted-underline"
                                v-if="lc_data.standard_since_when !== null && lc_data.standard_since_when !== ''"> {{
                                lc_data.standard_since_when }}</span>
                            <span v-else class="dotted-underline" style="font-weight: bold;">----</span>
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span><b> Reason of leaving school : </b></span>
                        <span class="dotted-underline" style="width: 511px;"
                            v-if="lc_data.reason !== null && lc_data.reason !== ''">{{ lc_data.reason }}</span>
                        <span v-else class="dotted-underline" style="width: 511px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span><b> Remark : </b></span>
                        <span class="dotted-underline" style="width: 634px;"
                            v-if="lc_data.remark !== null && lc_data.remark !== ''">{{ lc_data.remark }}</span>
                        <span v-else class="dotted-underline" style="width: 634px;font-weight:bold">----</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <span><b>Certified that the above information is in accordance with School General Register.
                            </b></span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <span><b>Date : {{ lc_data.gen_date }}</b></span>
                    </div>
                </div>
                <br />
                <br />
                <br />
                <div class="row pt-2">
                    <div class="col-4">
                        <span>
                            <center><b>Class Teacher</b></center>
                        </span>
                    </div>
                    <div class="col-4">
                        <span>
                            <center><b>Clerk</b></center>
                        </span>
                    </div>
                    <div class="col-4">
                        <span>
                            <center><b>Headmistress</b></center>
                        </span>
                    </div>
                </div>
                <hr class="hr-tag2" />
                <div class="row" style="line-height: 1.2rem;">
                    <div class="col-1 pt-2 pb-1 ml-none">Note:</div>
                    <!-- <div class="col-11 pt-2 pb-1 notranslate" v-if="org_id == 2" translate="no">
                        <div>1)शाळा सोडतेवेळी देण्यात येणाऱ्या लिव्हिंग सर्टिफिकेटमध्ये करावयाची कोणतीही दुरुस्ती तांबड्या शाईने मुख्याध्यापकाने संक्षिप्त सहीनिशी करावी.</div>
                        <div>2)  शाळा सोडण्याच्या दाखल्यामध्ये अनधिकृतरित्या बदल केल्यास संबंधितांवर कायदेशीर कारवाई करण्यात येईल.</div>
                    </div> -->
                    <div class="col-11 pt-2 pb-1">
                        <div>1) Any changes in school leaving certificate should be carried out in red ink with the
                            initiation of the Headmistress</div>
                        <div>2) Any infringenment of this rule is liable to rustication or other suitable
                            punishment.</div>
                    </div>
                    
     
                </div>
            </div>
        </div>
        </div>
    </div>
   
</template>
<script>
    export default {
      data() {
            return {
                lc_data: null,
                org_basic_data: null,
                last_date_of_school: "",
                org_id : null
            }
      },
       mounted() {
            this.lc_data = JSON.parse(localStorage.getItem("lc_data"));
            this.org_id = localStorage.getItem("EPS-org-id");
            // console.log(this.lc_data)
            this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
            this.last_date_of_school = localStorage.getItem("last_date_of_school");
        },
    };
</script>
<style scoped>
    .cardbody {
        /* border: 1px solid black; */
        width: 740px;
        display: inline-block;
        /* padding: 5px; */
        /* padding-top: 5px; */
        /* height: auto; */
        margin: 0 25%;
    }
     *{
    background-color: white;
    }
    .schlImg {
        width: 84%;
        /* height: 60%; */
        margin-left: 10%;
    }
    .lcheading1 {
        /* margin-left: 16%; */
        width: 64%;
        border-radius: 17px;
        border: 1px solid black;
        overflow: hidden;
    }
    .lcheading1_marathi {
        /* margin-left: 16%; */
        width: 64%;
        border: 1px solid black;
        overflow: hidden;
    }
    .hr-tag {
        height: 1px;
        border-width: 0px;
        color: black;
        background-color: black;
        width: 100%;
        /* margin-left: -12px; */
        margin-bottom: 4px;
    }
    .lcheading2 {
        margin-left: 30%;
        width: 42%;
        border-radius: 6px;
        margin-top: 3px;
        border: 1px solid black;
        text-transform: uppercase;
        overflow: hidden;
    }
    .lcheading2_marathi {
        margin-left: 30%;
        width: 42%;
        margin-top: 3px;
        border: 1px solid black;
        text-transform: uppercase;
        overflow: hidden;
    }
    .hr-tag2 {
        height: 1px;
        border-width: 0px;
        color: black;
        background-color: black;
        width: 100%;
    }
    .dotted-underline {
        border-bottom: 1px dashed;
        display: inline-block;
       padding-bottom: 3px;
        /* line-height: 1.2rem; */
    }
    .school-info {
        line-height: 0.3rem;
    }
    .stud-info {
        line-height: 0.5rem;
    }

    @media print {
        .schlImg {
            width: 84%;
        }
         .hr-tag2 {
        border: 1px solid black;
        width: 100%;        
        }  
        .schl-name-2{
            font-size: 21px;
        } 
        .cardbody{
            margin: 0;
            font-size: 14px;
        }
        @page {
            size: A4;
            margin-top: 8px;
            padding-top: 10px;
            /* size: 11.5in 17.5in; */

            size: 210mm 297mm;
            /* size: 10in 18in; */

            /* size: 10in 17in; */
        }
    }
</style>
